import { Link } from 'react-router';
import { RaceShowcase } from '../components/RaceShowcase';
import { RaceCard } from '../components/RaceCard';
import { useRaces } from '../api';
import { PageHeading } from '@/components/ui/PageHeading';
import { EmptyState } from '@/components/ui/EmptyState';

/**
 * Every race the public may see, in the order the API returns them: running
 * first, then awaiting results, then upcoming, then finished.
 *
 * The ordering is the server's decision rather than this page's, so the home
 * page's single card and this list can never disagree about which race is "the"
 * one.
 */
export function RacesPage() {
  const { data, isLoading, isError } = useRaces();

  return (
    <div className="w-full py-2">
      <PageHeading
        kind="trophy"
        eyebrow="Yarışmanın heyecanı"
        title="Wager Yarışmaları"
        description="Ödül havuzları, sıralamalar ve geri sayım. Sıralamada görünmek için profilinden casino kullanıcı adını kaydet."
      />

      {isLoading ? (
        <div className="flex flex-col gap-4">
          {Array.from({ length: 2 }, (_, index) => (
            <div key={index} className="h-72 animate-pulse rounded-2xl bg-surface-900/60" />
          ))}
        </div>
      ) : isError ? (
        <EmptyState title="Yarışmalar yüklenemedi." description="Lütfen sayfayı yenileyin." />
      ) : data && data.length > 0 ? (
        <div className="space-y-6">
          {data[0] ? (
            <RaceShowcase
              race={data[0]}
              headingLevel="h2"
              action={
                <Link
                  className="gf-button gf-button-primary mt-5 w-fit"
                  to={`/wager-races/${data[0].slug}`}
                >
                  Tüm sıralamayı gör <span aria-hidden="true">↗</span>
                </Link>
              }
            />
          ) : null}
          {data.length > 1 ? (
            <div className="grid gap-6 xl:grid-cols-2">
              {data.slice(1).map((race) => (
                <RaceCard key={race.id} race={race} />
              ))}
            </div>
          ) : null}
        </div>
      ) : (
        <EmptyState
          title="Şu anda aktif bir yarışma yok."
          description="Yenisi başladığında burada olacak."
        />
      )}
    </div>
  );
}
